// extracted by mini-css-extract-plugin
export default {"input-list":"FormImportFile_input-list__uqcXQ","dropZone":"FormImportFile_dropZone__JL1f6","dragOver":"FormImportFile_dragOver__lXNuZ","dropText":"FormImportFile_dropText__6wRAl"};